<template>
  <div id="app"  >
    <transition  :name="direction" >
      <router-view class="appView" :key="key"></router-view>
    </transition>
  </div>
</template>

<script>
  export default {
    name: 'app',
    data(){
      return{
        direction: "slide-right"
      }
    },
    computed: {
      key() {
        return this.$route.name !== undefined ? this.$route.name + +new Date() : this.$route + +new Date()
      }
    },
    watch: {
      $route(to, from) {
        // console.log("getPerformance",this.getPerformance())
        // console.log("getResources",this.getResources())
        // alert(to.path == from.path )
        // this.msgError = 0
        // let timer = setInterval(() => {
        //   this.msgError = this.msgError +1
        //   if (this.msgError == 1800) {
        //     clearInterval(timer)
        //     this.msgError = 0
        //     this.$router.go(0);
        //   }
        // }, 1000)
        sessionStorage.setItem('hasAll',to.meta.btnpermissions)
        const toDepth = to.path.split("/").length;
        const fromDepth = from.path.split("/").length;
        // if (to.path == "/") {
        //   this.direction = "slide-right";
        // } else if (from.path == "/") {
        //   this.direction = "slide-left";
        // }else{
        //   this.direction = toDepth < fromDepth ? "slide-right" : "slide-left";
        // }
      }
    },
    components: {
    },
    methods:{
       getPerformance () {
        if (!window.performance) return
        const timing = window.performance.timing
        const performance = {
          // 重定向耗时
          redirect: timing.redirectEnd - timing.redirectStart,
          // 白屏时间
          // whiteScreen: whiteScreen,
          // DOM 渲染耗时
          dom: timing.domComplete - timing.domLoading,
          // 页面加载耗时  这几乎代表了用户等待页面可用的时间
          load: timing.loadEventEnd - timing.navigationStart,
          // 页面卸载耗时
          unload: timing.unloadEventEnd - timing.unloadEventStart,
          // 请求耗时
          request: timing.responseEnd - timing.requestStart,
          // 获取性能信息时当前时间
          time: new Date().getTime(),
        }

        return performance
      },
      // 获取资源信息
     getResources(){
        if (!window.performance) return
        const data = window.performance.getEntriesByType('resource')
        const resource = {
          xmlhttprequest: [],
          css: [],
          other: [],
          script: [],
          img: [],
          link: [],
          fetch: [],
          // 获取资源信息时当前时间
          time: new Date().getTime(),
        }

        data.forEach(item => {
          const arry = resource[item.initiatorType]
          arry && arry.push({
            // 资源的名称
            name: item.name,
            // 资源加载耗时
            duration: item.duration.toFixed(2),
            // 资源大小
            size: item.transferSize,
            // 资源所用协议
            protocol: item.nextHopProtocol,
          })
        })

        return resource
      }

    },
    mounted() {
      // console.log("getPerformance",this.getPerformance())
      // console.log("getResources",this.getResources())
    }

  }
</script>

<!--<style src="assets/icon/iconfont.css"></style>-->
<style>
.ant-table-body::-webkit-scrollbar-track {
  display: none !important;
}
.ant-table .ant-table-placeholder {
  position: absolute;
  top: 55px;
  left: calc(50% - 32px);
  background-color: transparent;
  padding: 0 16px;
}
.ant-table-body {
  min-height: 200px;
}

.ant-table-body::-webkit-scrollbar {
  width: 8px;
  height: 8px;
  background: white;
}
.ant-table-body::-webkit-scrollbar-corner,
.ant-table-body::-webkit-scrollbar-thumb,
.ant-table-body::-webkit-scrollbar-track {
  border-radius: 4px;
}
.ant-table-body::-webkit-scrollbar-corner,
.ant-table-body::-webkit-scrollbar-track {
  background-color: #ddd;
  box-shadow: inset 0 0 1px #ddd;
}
.ant-table-body::-webkit-scrollbar-thumb {
  background-color: #c1c1c1;
}
  body{position: relative}
  body{overflow: hidden!important;box-sizing: border-box!important;}
  /*.cke_chrome{position: relative!important;}*/
  /*.ant-layout, .ant-layout *{position: relative!important;}*/
  .ant-modal-body{padding: 35px!important; }
  .top_btn{margin-right: 8px;margin-bottom: 15px}
  .ant-form-extra { position: absolute !important; }
  .ant-upload.ant-upload-select-picture-card{margin-bottom: 0!important;}
  .ant-upload-list-picture-card .ant-upload-list-item{margin: 0!important;}
  .ant-breadcrumb{position: relative;top:20px;left: 25px}
  .ant-form-explain, .ant-form-extra{color: #f5222d!important;}
  .ant-form-explain{color: #f5222d!important;}
  .ant-layout-content::-webkit-scrollbar {
    display: none;
  }
  .drawer-btn{
    position:  absolute!important;  ;
    right: 0!important ;
    bottom: 0!important ;
    width:  100%!important ;
    borderTop:  1px solid #e9e9e9!important ;
    padding:  10px 16px!important ;
    background:  #fff !important;
    textAlign:  right!important ;
    z-index:9!important
  }
 .selectClass .ant-cascader-menu-item-expand{white-space: break-spaces!important;overflow:auto;width:400px!important;word-break:break-all;overflow: hidden;display: -webkit-box;-webkit-line-clamp:1;-webkit-box-orient: vertical;    word-break: break-all;}
 .selectClass .ant-cascader-menu-item-expand{width:400px!important;}
 /*.selectClass .ant-cascader-menu-item-expand-icon{position: absolute!important;right: -10px!important;}*/
  .selectClass .ant-cascader-menu-item::-webkit-scrollbar {
    display: none!important;
  }
  .selectClass .ant-cascader-menu-item:hover .ant-cascader-menu-item-expand-icon{
    background: #e6f7ff;

  }
  .selectClass .ant-cascader-menu-item-expand-icon{background-color: #fff;width: 30px;position: absolute!important;right:-3px!important;transition: all .4s;top: 5px}
  /*.selectClass .ant-cascader-menu-item-expand:before{}*/
  .selectClass .ant-cascader-menu-item{white-space: break-spaces!important;max-width:400px!important;word-break:break-all;overflow: hidden;display: -webkit-box;-webkit-line-clamp: 1;-webkit-box-orient: vertical;word-break: break-all}
  .selectClass .ant-cascader-menu-item-active:not(.ant-cascader-menu-item-disabled) .ant-cascader-menu-item-expand-icon, .ant-cascader-menu-item-active:not(.ant-cascader-menu-item-disabled):hover .ant-cascader-menu-item-expand-icon{background-color: #fafafa}
  /*.big_box{background-color: #fff;margin-top: 20px;min-height:80vh;padding: 20px;box-sizing: border-box;height: 80vh;overflow-y: scroll}*/
  /*.big_box::-webkit-scrollbar{display:none }*/
  .appView {
    position: absolute!important;
    width:100%;
    transition: transform 0.3s ease-out;
  }
  .slide-left-enter{
    transform: translate(100%, 0);
  }
  .slide-left-leave-active{
    transform: translate(-50%, 0);
  }
  .slide-right-enter {
    transform: translate(-50%, 0);
  }
  .slide-right-leave-active{
    transform: translate(100%, 0);
  }
  .seachBox {
    margin: 0 auto;
    margin-top: 10px;
    margin-bottom: 20px
  }
  .seachBox{padding: 15px 10px;  background-color: #f5f7fa; box-sizing: border-box;position: relative}
  .seachBox .seachList{width:19.5%;margin: 5px 0 }
  .seachBox .seachList.no{margin: 0}
  .seachBox .seachList .name{float: left;display: inline-block;width: 85px!important;line-height: 30px;text-align: right}
  .seachBox .seachList .seachs{width: calc(100% - 90px)}
  .seachBox .seachBtnBox{width:19.5%;  margin: 0;position: absolute;right: 0;margin-top: -5px}
  .seachBox .seachBtnBox .seachBtn{margin-left: 10px;margin-top: 10px}
  /*
  ***重置样式***
  */
  html,body,h1,h2,h3,h4,h5,h6,div,dl,dt,dd,ul,ol,li,p,pre,hr,table,th,td,form,input,button,textarea{margin:0;padding:0;}
p {
  margin-top: 0;
  margin-bottom: 1em;
}
  header,footer,section,article,aside,nav,hgroup,address,figure,figcaption,menu,details{display:block;}
  table{border-collapse:collapse;border-spacing:0;}
  img,iframe{border:0;}
  i,em{font-style:normal;}
  li,ul,ol{list-style:none;}
  h1,h2,h3,h4,h5,h6{font-size:100%;}
  textarea{overflow:auto; }
  label{cursor:default;}
  button,input[type="button"], input[type="submit"]{cursor:pointer;}
  h1,h2,h3,h4,h5,h6,em,strong,b{font-weight:bold;}
  /*a,a:hover,a:active{color:#333;text-decoration:none;}*/
  input,textarea,button{ background:none;  border:none; outline:none; font-family:"Microsoft YaHei", Helvetica, Arial, sans-serif; font-size:12px; }
  /*select{-webkit-appearance:none; appearance:none;}*/
  /*
  ***全局公共样式***
  */
  html {  font-size: 62.5%;}
  body{font-size: 14px; font-size: 1.4rem;  color: #333;  margin: 0 auto;  font-family: 'Microsoft YaHei',Helvetica,Arial,sans-serif;  -webkit-tap-highlight-color: transparent;}
  /*浮动*/
  .fl ,.lt {  float: left;  }
  .fr ,.rt {  float: right;  }
  /*清除浮动*/
  .clearfix:after{content:"";display:block;clear:both;}
  .clearfix{zoom:1;}
  .clear {clear:both;}
  .flex{display: flex;display:-webkit-flex;justify-content: space-between;flex-wrap: wrap}
  /*placeholder 颜色*/
  :-moz-placeholder { color: #666; }
  ::-moz-placeholder { color: #666;}
  input:-ms-input-placeholder{ color: #666;}
  input::-webkit-input-placeholder{ color: #666;}
  /****主体宽度****/
  .wrap{width:1200px;margin: 0 auto;}
  /*数字输入框按钮*/
  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    -webkit-appearance: none;
  }

  input[type="number"] {
    -moz-appearance: textfield
  }

  /*.ant-menu-item > a {*/
  /*  color: #fff;*/
  /*}*/
  .replaceFields{max-width: 300px!important;max-height: 400px!important; }
  .ant-menu-item > a.router-link-active {
    color: #1890ff;
  }
  .ant-layout-content{flex: unset!important;min-height: auto!important;}
  .ant-layout-content::-webkit-scrollbar {
    display: none;
  }
  @media(max-width:1219px){
    .wrap{width: 90%;}
  }
  @media(max-width:767px){
    .wrap{width: 96%;}
  }
</style>
